import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'httplink'
})
export class HttplinkPipe implements PipeTransform {

  transform(href: string): any {
    if (href == null) return;
    return href.startsWith("http://") || href.startsWith("https://") ? href : "http://" + href;
  }

}
